
import React from 'react';
import { QueueItem } from '../types';

interface QueueManagerProps {
  queue: QueueItem[];
  onCancel: (id: string) => void;
  isFallbackActive: boolean;
}

const QueueManager: React.FC<QueueManagerProps> = ({ queue, onCancel, isFallbackActive }) => {
  return (
    <div className="bg-[#1e222d] rounded border border-[#2a2e39] overflow-hidden">
      <div className="p-3 border-b border-[#2a2e39] bg-[#131722]/40 flex justify-between items-center">
        <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-widest flex items-center gap-2">
          <i className="fas fa-layer-group text-yellow-500"></i>
          Active Pipeline
          <span className="ml-2 px-1.5 py-0.5 bg-yellow-500/10 text-yellow-500 text-[9px] rounded font-mono">
            {queue.length} PENDING
          </span>
        </h3>
        {isFallbackActive && (
          <div className="flex items-center gap-1.5 px-2 py-0.5 bg-orange-500/10 border border-orange-500/20 rounded">
            <i className="fas fa-bolt text-orange-500 text-[9px]"></i>
            <span className="text-[8px] font-black text-orange-500 uppercase">Fallback Link</span>
          </div>
        )}
      </div>
      
      <div className="max-h-[200px] overflow-y-auto">
        {queue.length === 0 ? (
          <div className="p-8 text-center text-slate-600 italic text-[10px] uppercase font-bold tracking-widest">
            Pipeline Clear
          </div>
        ) : (
          <table className="w-full text-left text-[10px] border-collapse font-mono">
            <thead>
              <tr className="text-slate-600 border-b border-[#2a2e39] bg-[#131722]/20">
                <th className="p-2 font-bold uppercase">Source</th>
                <th className="p-2 font-bold uppercase">Type</th>
                <th className="p-2 font-bold uppercase">Latency</th>
                <th className="p-2 font-bold uppercase text-right">Op</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#2a2e39]/40">
              {queue.map((item) => (
                <tr key={item.id} className="hover:bg-[#2a2e39]/20 transition-colors group">
                  <td className="p-2">
                    <span className="font-bold text-slate-400 tracking-tighter uppercase">{item.clientName}</span>
                  </td>
                  <td className="p-2">
                    <span className="text-purple-400 font-bold uppercase">{item.modelId.split('-')[0]}</span>
                  </td>
                  <td className="p-2">
                    <span className="text-yellow-500 font-bold">
                      {Math.floor((Date.now() - new Date(item.timestamp).getTime()) / 1000)}s
                    </span>
                  </td>
                  <td className="p-2 text-right">
                    <button 
                      onClick={() => onCancel(item.id)}
                      className="text-slate-600 hover:text-red-500 p-1 transition-all"
                    >
                      <i className="fas fa-trash-alt text-[9px]"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default QueueManager;
